import { MAT_ICON_DEFAULT_OPTIONS } from "@angular/material/icon";
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from "@angular/router";
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import {routes} from './app.routes';
import {provideHttpClient} from '@angular/common/http';
import {FileText, Globe, LUCIDE_ICONS, LucideIconProvider, Phone} from 'lucide-angular';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), {
      provide: MAT_ICON_DEFAULT_OPTIONS,
      useValue: {
        fontSet: 'material-symbols-outlined',
      },
    },provideHttpClient(),
    {
      provide: LUCIDE_ICONS,
      multi: true,
      useValue: new LucideIconProvider({
        Phone,
        FileText,
        Globe,
      })
    },



    provideRouter(routes), provideCharts(withDefaultRegisterables())]
};
